/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetMediaResponse } from '../../models/get-media-response';

export interface MediaServiceGetMedia$Params {

/**
 * Media ID.
 * Required.
 */
  mediaId: string;
}

export function mediaServiceGetMedia(http: HttpClient, rootUrl: string, params: MediaServiceGetMedia$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMediaResponse>> {
  const rb = new RequestBuilder(rootUrl, mediaServiceGetMedia.PATH, 'get');
  if (params) {
    rb.path('mediaId', params.mediaId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetMediaResponse>;
    })
  );
}

mediaServiceGetMedia.PATH = '/api/v3/gateway/media/{mediaId}';
